import axios from "axios";
import { API_BASE_URL } from "../config/api";

const getAuthHeaders = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const getMarketUserBook = async (token, matchId, marketType) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/lords/net-exposure/market-book/${matchId}?marketType=${marketType}`,
            getAuthHeaders(token)
        );
        return response.data;
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const getMatchExposureSummary = async (token, matchId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/lords/net-exposure?matchId=${matchId}`,
            getAuthHeaders(token)
        );
        return response.data;
    } catch (error) {
        return { success: false, message: error.message };
    }
};
